import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import sounds from 'src/lib/sounds';
import * as Social from 'src/replicant/social';
import { Feature } from 'src/replicant/analytics';
import { user } from '../../StateObserver';
import features from '../../replicant/ruleset/features';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupInviteChallengeComplete extends PopupBasic {
  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: uiConfig.popups.minimumWidth,
      height: 705,
      tracking: {
        feature: Feature.INVITE._,
        $subFeature: 'popup-invite-challenge-complete',
      },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      width: this.box.style.width - 80,
      height: 130,
      x: 40,
      y: 290,
      color: '#754111',
      zIndex: 1,
    });

    new ImageScaleView({
      superview: this.box,
      height: 186,
      width: 186,
      x: this.box.style.width / 2,
      y: 190,
      centerOnOrigin: true,
      image: 'assets/ui/inviteChallenge/mission_confetti.png',
    });

    new ImageScaleView({
      superview: this.box,
      height: 5,
      width: this.message.style.width - 170,
      x: 125,
      y: 424,
      image: 'assets/ui/popups/panel_underline.png',
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: { left: 5, right: 5 },
      },
    });

    new LangBitmapFontTextView({
      superview: this.box,
      size: 20,
      font: 'Body',
      height: 100,
      width: this.box.style.width - 80,
      x: 40,
      verticalAlign: 'center',
      align: 'center',
      y: 450,
      color: '#C1935D',
      localeText: () => i18n('social.inviteChallenge.complete.rewardDetails'),
    });

    new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.secondary,
      labelOffsetX: -4,
      labelOffsetY: -1,
      fontSize: 38,
      font: bitmapFonts('Body'),
      x: this.box.style.width / 2,
      y: this.box.style.height - 35 - 80 / 2,
      width: 229,
      height: 80,
      centerOnOrigin: true,
      localeText: () => i18n('basic.ok'),
      onClick: async () => {
        sounds.playSound('ok');
        opts.close();
      },
      tracking: {
        feature: Feature.INVITE._,
        $subFeature: 'popup-invite-challenge-ok',
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      'assets/ui/inviteChallenge/mission_confetti.png',
      'assets/ui/popups/panel_underline.png',
    ]);
  }

  public init() {
    super.init({
      title: i18n('social.inviteChallenge.complete.title'),
      message: i18n('social.inviteChallenge.complete.message', {
        target: Social.getters.getInviteChallengeTarget(user()),
      }),
    });
  }
}
